module.exports = __webpack_public_path__ + "img/news_8.ec659dd0.jpeg";